import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=6f931d6e&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
import style0 from "./Tag.vue?vue&type=style&index=0&id=6f931d6e&prod&lang=scss&scoped=true"
import style1 from "./Tag.vue?vue&type=style&index=1&id=6f931d6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f931d6e",
  null
  
)

export default component.exports